import { ApiDispatcher } from '../common-bootstrap/ApiDispatcher';
import { Dialog } from './Dialog';

export class DialogWindow implements Dialog {
  private activeDialogWindow: Window | null = null;
  private _isCreated = false;

  public constructor(private _width: string, private _height: string, private _url: string, private handleUserCloseEvent: () => void) {}

  public get isOpen(): boolean {
    return this.activeDialogWindow !== null && !this.activeDialogWindow.closed;
  }

  public get isCreated(): boolean {
    return this._isCreated;
  }

  public get width(): string {
    return this._width;
  }

  public get height(): string {
    return this._height;
  }

  public get url(): string {
    return this._url;
  }

  public async createDialog(): Promise<void> {
    if (this._isCreated) {
      return;
    }

    this.activeDialogWindow = window.open(
      this._url,
      '_blank',
      `height=${this._height},width=${this._width},menubar=no,toolbar=no,location=no,directories=no,status=no,scrollbars=yes,resizable=yes,dependent`,
    );

    // window.open returns null when the browser blocks the popup(Popup Blocker).
    // in that log the error and return.
    if (this.activeDialogWindow === null) {
      console.error('Unable to initialize Popup Window: Please check your browser Popup setting');
      return;
    }

    // This small interval catches the case where the user closes the dialog themselves,
    // before the extension code has called tableau.extensions.ui.closeDialog. The parent
    // extension needs to be notified that that happened.
    let closeInterval = setInterval(() => {
      if (this.activeDialogWindow?.closed) {
        this.handleUserCloseEvent();
        clearInterval(closeInterval);
      }
    }, 200);

    this._isCreated = true;
  }

  public closeDialog(): void {
    if (!this.isOpen) {
      return;
    }
    this.activeDialogWindow!.close();
  }

  public cleanupDialog(): void {
    if (this.isOpen) {
      this.closeDialog();
    }
    this._isCreated = false;
    this.activeDialogWindow = null;
  }

  public showDialog(dialogDispatcher: ApiDispatcher): void {
    if (!this._isCreated) {
      return;
    }
    dialogDispatcher.setExtensionWindow(this.activeDialogWindow!);
  }
}
